// Brand assets for MAZID SCHOOL CONNECT — uniquement les images RÉELLES de l'école
export const ASSETS = {
  // Logo officiel carré : globe vert/orange + bannière "LES ÉCOLES MAZID" + "FAISONS MIEUX"
  logo: "https://customer-assets.emergentagent.com/job_d6791832-0b4f-4ef9-972e-5c2b412baa9a/artifacts/26b7350h_WhatsApp%20Image%202026-06-26%20at%2020.17.37.jpeg",
  // 3 vraies photos du bâtiment (juin 2026)
  buildings: [
    "https://customer-assets.emergentagent.com/job_mazid-smart-school/artifacts/uafmxu7r_27%20juin%202026%2C%2010_41_49.png",
    "https://customer-assets.emergentagent.com/job_mazid-smart-school/artifacts/9ukbo0w1_27%20juin%202026%2C%2010_41_52.png",
    "https://customer-assets.emergentagent.com/job_mazid-smart-school/artifacts/o7qroto3_ChatGPT%20Image%2027%20juin%202026%2C%2010_45_01.png",
  ],
  // Alias pratique : la photo principale (la première de la liste)
  building: "https://customer-assets.emergentagent.com/job_mazid-smart-school/artifacts/uafmxu7r_27%20juin%202026%2C%2010_41_49.png",
  // Vraie photo / portrait du fondateur
  founder: "https://customer-assets.emergentagent.com/job_mazid-smart-school/artifacts/dm2n0lwc_WhatsApp%20Image%202026-06-26%20at%2021.02.20.jpeg",
  // Vraies vidéos WhatsApp fournies par l'école (vidéo du fondateur retirée à la demande du client)
  videos: [
    "https://customer-assets.emergentagent.com/job_mazid-smart-school/artifacts/z2s73utj_WhatsApp%20Video%202026-06-26%20at%2020.59.20.mp4",
  ],
};

export const SCHOOL_INFO = {
  name: "LES ÉCOLES MAZID",
  tagline: "Faisons mieux",
  slogan: "Former, accompagner et révéler le potentiel de chaque enfant.",
  address: "Quartier Tobolon, secteur Mathossya, Conakry, Guinée",
  phones: ["+224 628 98 19 58", "+224 622 44 31 39", "+224 622 66 82 77"],
  email: "contact@ecoles-mazid.gn",
  whatsapp: "+224 628 98 19 58",
  facebook: "https://www.facebook.com/share/1bQ7kh48bS/?mibextid=wwXIfr",
  arrete: "Arrêté Ministériel N° A/2022/265/MEPU-A/SGG portant ouverture d'un Établissement d'Enseignement Privé",
};
